import { render, staticRenderFns } from "./AppItem.vue?vue&type=template&id=24b33ec8&scoped=true&"
import script from "./AppItem.vue?vue&type=script&lang=js&"
export * from "./AppItem.vue?vue&type=script&lang=js&"
import style0 from "./AppItem.vue?vue&type=style&index=0&id=24b33ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b33ec8",
  null
  
)

export default component.exports